import { AccountConfigFlags } from "../constants/enum";

interface AccountConfig {
	[key: string]: Set<string>;
}

const accountConfig: AccountConfig = {
	[AccountConfigFlags.BenchTest]: new Set(["40ccb35f-f2bb-4e50-b121-6f7b366b9408", "local"]),
	[AccountConfigFlags.AcceptanceTest]: new Set(["edca08ab-8979-441f-8b16-16682e188019", "local"]),
	[AccountConfigFlags.BrLoghis]: new Set(["a4df6bef-b4fe-41cf-a132-f68789aa466d", "local"]),
	[AccountConfigFlags.Dn]: new Set(["9657bf03-9bcd-428c-8169-768f5b3b7f6d", "local"]),
	[AccountConfigFlags.VolksUptime]: new Set(["b1cbe9de-be81-4c67-9a8f-bdcbc782ab50", "local"]),
	[AccountConfigFlags.PresentationAccountIds]: new Set([
		"7c821519-a280-43a6-8746-2c82b00530ed", // frota demonstração
		"4924568e-23f3-40f9-9730-ff88efc41172", // JSP
	]),
};

export const checkAccountFlag = (accountId: string, flag: AccountConfigFlags): boolean => {
	return accountConfig[flag]?.has(accountId) ?? false;
};
